module.exports = __webpack_public_path__ + "img/rique-ava.af1be3d.png";